import React from 'react'
import { Box, BoxProps } from '@chakra-ui/react'

const ResponsiveBox: React.FC<BoxProps> = props => {
  return <Box px={[4, 4, 6, 8, 8]} {...props} />
}

export default ResponsiveBox
